import React from 'react';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import { t } from '../common/Translate';

const InfoBullItem = ({ tooltipOpen, id, openInfoBull, message, placement }) => (
  <>
    <FontAwesomeIcon icon={faInfoCircle} size="1x" id={id} className="info-icon" onClick={openInfoBull} />
    <Tooltip placement={placement} isOpen={tooltipOpen} target={id} toggle={!isMobile && openInfoBull}>
      {t(message)}
    </Tooltip>
  </>
);
InfoBullItem.propTypes = {
  tooltipOpen: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  openInfoBull: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

InfoBullItem.defaultProps = {
  placement: 'bottom',
};
export default InfoBullItem;
